// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad7b5912","455":"f261ab50","977":"9a0fb065"}[chunkId] + ".chunk.js";
};